/**
 * @property titleStyle {obj} title style
 * @property tipText {text} tip text
 * @property newPasswordOnChange {function} params: 1.event object, 2, value. callback of new password field value change
 * @property confirmPasswordOnChange {function} params: 1.event object, 2, value. callback of confirm password field value change
 */
import React, {Component} from 'react';
import InputField from '../../framework/InputField/InputField';

class CreateYourPassword extends Component {
  handleNewPassword (e, value) {
    this.props.newPasswordOnChange(e, value);
  }
  handleConfirmPassword (e, value) {
    this.props.confirmPasswordOnChange (e, value);
  }
  _pwdInputKeyDown(e) {
    if (e.keyCode === 32)
      e.preventDefault();
  }
  render () {
    const initTitStyle={
      fontSize: '18px',
      fontWeight: 'bolder'
    }
    return (
      <div className="profile-change-pw">
        <h1 style={{...initTitStyle, ...this.props.titleStyle}}>CHANGE YOUR PASSWORD</h1>
        <p className="tip">
          Enter a combination of at least 6 numbers, letters, and special characters
        </p>
        <div className="profile-username">
          {/*{*/}
            {/*this.state.showNewPwError && (*/}
              {/*<p className="profile-fn-error">*/}
                {/*{this.props.change_password_error_msg}*/}
              {/*</p>*/}
            {/*)*/}
          {/*}*/}
          <div className="profile-fn-wrapper">
            <InputField
              labelTitle='New Password'
              ifRequireField={true}
              inputType="password"
              labelStyle={{float:'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0}}
              inputContainerId="change-password"
              borderColor="black"
              onKeyDown={this._pwdInputKeyDown}
              onChange={(e, value) => this.handleNewPassword(e, value)}
              style={{height: '32px', lineHeight: '32px', marginBottom: '49px'}}
            />
          </div>
          <div className="profile-fn-wrapper">
            <InputField
              labelTitle='Confirm Password'
              ifRequireField={true}
              inputType="password"
              labelStyle={{float:'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0}}
              inputContainerId="change-password"
              borderColor="black"
              onKeyDown={this._pwdInputKeyDown}
              onChange={(e, value) => this.handleConfirmPassword(e, value)}
              style={{height: '32px', lineHeight: '32px', marginBottom: '40px'}}
            />
          </div>

        </div>
      </div>
    )
  }
}

export default CreateYourPassword;


// WEBPACK FOOTER //
// ./src/components/framework/CreateYourPassword/CreateYourPassword.jsx